import { styled } from '@mui/material';
import { IconCaretLeft } from 'assets/img';

export const SidebarToggle = ({
  isSidebarOpen,
  handleClose,
  handleOpen,
}: {
  isSidebarOpen: boolean;
  handleClose: () => void;
  handleOpen: () => void;
}) => {
  return (
    <StyledSidebarToggle
      folded={!isSidebarOpen}
      color="secondary"
      onClick={isSidebarOpen ? handleClose : handleOpen}
    >
      <IconCaretLeft />
    </StyledSidebarToggle>
  );
};

const StyledSidebarToggle = styled('button')<{ folded: boolean }>(({ theme, folded }) => ({
  alignItems: 'center',
  backgroundColor: theme.palette.common.white,
  border: 0,
  borderRadius: '46px',
  bottom: '35px',
  boxShadow: `0px 8px 20px ${theme.palette.lwPrimaryAccentLight[10]}`,
  cursor: 'pointer',
  display: 'flex',
  height: '40px',
  justifyContent: 'center',
  left: folded ? '90px' : '220px',
  opacity: 1,
  position: 'fixed',
  transform: folded ? 'rotateY(180deg)' : '',
  transition: theme.transitions.create('all', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  width: '56px',
  zIndex: 1200,

  '& svg path': {
    stroke: theme.palette.lwPrimaryAccentDark[100],
  },
}));
